import View from "../../assets/Vector (1).svg";
import Assign from "../../assets/Vector (2).svg";
import Recall from "../../assets/Vector (3).svg";
import Edit from "../../assets/Vector (4).svg";
import {
  ETableRowActionFieldApplicable,
  INotificationTableActions,
  ITableRowActionField,
} from "../NotificationMangement";
import { Popover, Tooltip, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import { showErrorNotification } from "../../modal/Tostify";

import {
  INotificationTableList,
  NotificationActions,
} from "../../../../slices/NotificationSlice";
import { getAssignUser } from "../../../../api/ssoapi/UserControlapi";
import { useState } from "react";

interface ActionButtonsProps {
  row: INotificationTableList;
  onEdit: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  row,
  onEdit,
}) => {
  const user = useSelector((state: RootState) => state.user.user);
  const dispatch = useDispatch<AppDispatch>();
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  const handleViewNotification = (row: INotificationTableList): void => {
    try {
      dispatch(NotificationActions.UpdateViewPopup(true));
      // setEnableViewNotification(true);
      dispatch(NotificationActions.GetDataById({ id: row.notificationID }));
    } catch (error) {
      showErrorNotification("Error fetching View Notification");
    }
  };

  const getButtonState = (
    actions: INotificationTableActions
  ): {
    assign: boolean;
    recall: boolean;
    edit: boolean;
    view: boolean;
  } => {
    return {
      view: actions.view.applicable === ETableRowActionFieldApplicable.Show,
      assign: actions.assign.applicable === ETableRowActionFieldApplicable.Show, // Fixed: was using view instead of assign
      recall: actions.recall.applicable === ETableRowActionFieldApplicable.Show, // Fixed: was using view instead of recall
      edit: actions.edit.applicable === ETableRowActionFieldApplicable.Show, // Fixed: was using view instead of edit
    };
  };

  const buttonState = getButtonState(row.actions);

  const getApplicableState = (action: ITableRowActionField) => {
    if (action.applicable === ETableRowActionFieldApplicable.Blur) {
      return " button-opacity ";
    }
    return "";
  };

  const handleToEditNotification = (e: React.MouseEvent): void => {
    try {
      dispatch(NotificationActions.GetDataById({ id: row.notificationID }));
      dispatch(NotificationActions.UpdateVisible(false));
      setIsPopoverVisible(false);
      onEdit();
    } catch (error) {
      showErrorNotification("Error fetching notification data getById");
    }
  };

  const handleAssignUser = (data: INotificationTableList): void => {
    dispatch(NotificationActions.GetDataById({ id: row.notificationID }));
    dispatch(NotificationActions.UpdateEnableAssign(true));
    if (data.level === "LEVEL_1" || "LEVEL_2") {
      dispatch(getAssignUser(data.level));
    }
  };

  const handleDeleteNotification = (id: string): void => {
    dispatch(NotificationActions.UpdateId(id));
    dispatch(NotificationActions.UpdateDeletePopup(true));
    setIsPopoverVisible(false);
  };

  const handleRecallNotification = (): void => {
    dispatch(NotificationActions.GetDataById({ id: row.notificationID }));
    dispatch(NotificationActions.UpdateRecallAction(true));
  };

  const content = (
    <div>
      {row.actions.edit.applicable !== ETableRowActionFieldApplicable.Hide && (
        <Tooltip title={row.actions.edit.message}>
          <div>
            <button
              disabled={
                row.actions.edit.applicable ===
                ETableRowActionFieldApplicable.Blur
              }
              type="button"
              onClick={(e) =>
                row.actions.edit.applicable ===
                  ETableRowActionFieldApplicable.Show &&
                handleToEditNotification(e)
              }
              className={`edit-options-button ${getApplicableState(
                row.actions.edit
              )}`}
            >
              Edit
            </button>
          </div>
        </Tooltip>
      )}

      {row.actions.delete.applicable !==
        ETableRowActionFieldApplicable.Hide && (
        <Tooltip title={row.actions.delete.message} placement="right">
          <div>
            <button
              disabled={
                row.actions.delete.applicable ===
                ETableRowActionFieldApplicable.Blur
              }
              type="button"
              onClick={(e) =>
                row.actions.delete.applicable ===
                  ETableRowActionFieldApplicable.Show &&
                handleDeleteNotification(row.notificationID)
              }
              className={`edit-options-button ${getApplicableState(
                row.actions.delete
              )}`}
            >
              Delete
            </button>
          </div>
        </Tooltip>
      )}
    </div>
  );

  return (
    <div className="actions-container">
      <Tooltip title={row.actions.view.message}>
        <button
          className="action-icon-button"
          id={`${row.nUniqueID}`}
          onClick={() => handleViewNotification(row)}
          disabled={!buttonState.view}
        >
          <img
            src={View}
            alt="view_icon"
            className={`icon-style ${getApplicableState(row.actions.view)}`}
          />
        </button>
      </Tooltip>

      <Tooltip title={row.actions.assign.message}>
        <span>
          <button
            className="action-icon-button"
            id={`${row.nUniqueID}`}
            onClick={() => buttonState.assign && handleAssignUser(row)}
            disabled={!buttonState.assign}
          >
            <img
              src={Assign}
              alt="assign-icon"
              className={`icon-style ${getApplicableState(row.actions.assign)}`}
            />
          </button>
        </span>
      </Tooltip>

      <Tooltip title={row.actions.recall.message}>
        <span>
          <button
            className="action-icon-button"
            id={`${row.nUniqueID}`}
            onClick={() => buttonState.recall && handleRecallNotification()}
            disabled={!buttonState.recall}
          >
            <img
              src={Recall}
              alt="recall-icon"
              className={`icon-style ${getApplicableState(row.actions.recall)}`}
            />
          </button>
        </span>
      </Tooltip>
      <Space wrap>
        <Popover
          placement="topRight"
          content={content}
          trigger="click"
          open={isPopoverVisible}
          onOpenChange={(visible) => setIsPopoverVisible(visible)}
        >
          <button className="action-icon-button" id={`${row.notificationID}`}>
            <img src={Edit} alt="edit-icon" className="icon-style" />
          </button>
        </Popover>
      </Space>
    </div>
  );
};

export default ActionButtons;
